module.exports = __webpack_public_path__ + "static/media/test.e38cf222.jpg";